module.exports = __webpack_public_path__ + "img/3.ddf24c49.png";